import { Card } from "@ebsco-ui/ebsco-ui";
import React from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../../../constants";
import sharedMessages from "../../../../shared-messages";
import { navigateToMyAccountPage } from "../../../store/navigation/navigation";
import PageHeader from "../../page-header";
import SecretQuestionUpdateForm from "../secret-question-update-form";
import messages from "./secret-question-update-page-messages";

import "./secret-question-update-page.scss";

const block = "secret-question-update-page";

const SecretQuestionUpdatePage = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const myAccountPageUrl = `${ROUTES.ACCOUNT_UPDATE}${search}`;
  const handleNavigateToMyAccountPageClick = () => {
    dispatch(navigateToMyAccountPage(myAccountPageUrl));
  };

  return (
    <main className={block}>
      <PageHeader
        returnUrl={myAccountPageUrl}
        onReturnLinkClick={handleNavigateToMyAccountPageClick}
        isExternalLink={false}
        returnLinkText={formatMessage(sharedMessages.backToMyAccount)}
        pageTitleText={formatMessage(messages.changeMySecretQuestion)}
      />
      <Card
        isRaised
        isRounded={false}
        isTransparent={false}
        border="all"
        className={`${block}__card`}
      >
        <SecretQuestionUpdateForm />
      </Card>
    </main>
  );
};

export default SecretQuestionUpdatePage;
